import { TableCell, TableRow } from '@mui/material';

import { CampaignProductDailyReport } from '~/types';

export type SponsoredProductsReportsBannerRowProps = {
  resume: CampaignProductDailyReport;
};

export function SponsoredProductsReportsBannerRow({
  resume,
}: SponsoredProductsReportsBannerRowProps) {
  return (
    <TableRow
      key={resume.date}
      sx={{
        whiteSpace: 'nowrap',
        '.MuiTableCell-body': {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <TableCell component="th" scope="row">
        {resume.date ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row">
        {resume.impressions ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row">
        {resume.clicks ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row">
        {resume.ctr ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row">
        {resume.cpm ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row">
        {resume.cpc ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row">
        {resume.cpi ?? '-'}
      </TableCell>
    </TableRow>
  );
}
